module.exports = __webpack_public_path__ + "img/delegated.17c04f8c.png";